const STORAGE_KEY = 'neatComingSoonUnlock';
const ENABLED_CACHE_KEY = 'neatComingSoonEnabled';

function readStorage(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // ignore
  }
}

export function hasComingSoonAccess() {
  return readStorage(sessionStorage, STORAGE_KEY) === '1';
}

export function grantComingSoonAccess() {
  writeStorage(sessionStorage, STORAGE_KEY, '1');
}

export function cacheComingSoonEnabled(enabled) {
  writeStorage(localStorage, ENABLED_CACHE_KEY, enabled ? '1' : '0');
}

export function cachedComingSoonEnabled() {
  const local = readStorage(localStorage, ENABLED_CACHE_KEY);
  if (local === '1') return true;
  if (local === '0') return false;

  const session = readStorage(sessionStorage, ENABLED_CACHE_KEY);
  if (session === '1') {
    cacheComingSoonEnabled(true);
    return true;
  }
  if (session === '0') {
    cacheComingSoonEnabled(false);
    return false;
  }

  return null;
}
